import { EditButton as ReactAdminEditButton, EditButtonProps } from 'react-admin'

export const EditButton = (props: EditButtonProps): JSX.Element => {
  return <ReactAdminEditButton {...props} size='medium' />
}
